<app-modal-base
  [showCloseIcon]="true"
  [primaryButtonText]="'tryToLogin' | translate"
  [showSecondaryButton]="false"
  (close)="dialogRef.close(true)"
  (primaryClick)="dialogRef.close(true)"
>
  <p class="text-gray-600">
    {{ 'youCannotLoginWithAnUnverifiedEmail' | translate }}
  </p>
</app-modal-base>
